// @ts-nocheck
// ====== Onboarding tour (primo login admin) ======
// Mostra 4 popover sequenziali ancorati ai principali punti di ingresso.
// Stato: una flag `tour_seen=true` viene salvata in user_preferences alla
// prima conclusione. L'admin può rilanciare il tour da Impostazioni.
//
// Help contestuale: ogni elemento con attributo `data-help` mostra un
// tooltip espandibile al click sul suo `?` accanto. Vedi tooltip-help.js
// (parte di questo modulo per non frammentare).

// Tour adattato al ruolo: gli admin vedono i punti di regìa (attenzione, crea
// cliente); gli utenti (i colleghi del team) vedono come consultare e cosa
// possono modificare. Così anche chi entra per la prima volta capisce subito.
const ADMIN_STEPS = [
  {
    selector: '#attentionPanel',
    title: 'Cosa richiede attenzione oggi',
    body: 'In cima alla Dashboard trovi raccolti gli avvisi più importanti dell’area: contratti in scadenza, clienti senza responsabile, accessi fermi. È il tuo punto di partenza ogni mattina.',
    placement: 'bottom'
  },
  {
    selector: '.sidebar .nav',
    title: 'Menù principale',
    body: 'Le voci sono raggruppate in Panoramica, Operatività, Team, Supervisione e Sistema. Il gruppo "Supervisione" è riservato agli admin.',
    placement: 'right'
  },
  {
    selector: '#globalSearch',
    title: 'Cerca veloce',
    body: 'Da qui (o con Ctrl/Cmd+K) apri la ricerca unica del portale: clienti, risorse, persone e sezioni, da qualsiasi schermata. Per filtrare l’elenco clienti usa invece la casella di ricerca dentro la vista Clienti.',
    placement: 'bottom'
  },
  {
    selector: '#btnOpenQuickSwitcher',
    title: 'Quick switcher · ⌘K',
    body: 'Premi Ctrl/Cmd+K (o "/") per aprire la palette di navigazione: salta direttamente a un cliente, una risorsa o una vista.',
    placement: 'bottom'
  },
  {
    selector: '#btnAddClient',
    title: 'Crea un cliente',
    body: 'Da qui apri il modulo per inserire un nuovo cliente con tutti i dati: anagrafica, accessi, contratto, referenti, documenti, scadenze.',
    placement: 'bottom'
  }
];

const USER_STEPS = [
  {
    selector: '.sidebar .nav',
    title: 'Benvenuto nel Portale Ma.Se.',
    body: 'È lo strumento del team Managed Services per consultare clienti, risorse e riferimenti. Dal menù raggiungi Dashboard, Clienti, Risorse e Riferimenti interni.',
    placement: 'right'
  },
  {
    selector: '#globalSearch',
    title: 'Cerca veloce',
    body: 'Premi qui (o Ctrl/Cmd+K) per aprire la ricerca: trova clienti, persone e sezioni da qualunque schermata. Non serve sapere dove sono.',
    placement: 'bottom'
  },
  {
    selector: '#myActionList',
    title: 'Le tue cose',
    body: 'In Dashboard la sezione "Le tue azioni aperte" raccoglie le utenze che riguardano te: così vedi a colpo d’occhio cosa ti aspetta.',
    placement: 'top'
  },
  {
    selector: '#step-no-anchor',
    title: 'Cosa puoi modificare',
    body: 'Aprendo un cliente puoi aggiornare lo stato del tuo accesso (la tua riga). Il resto è in sola lettura: la regìa complessiva è del responsabile d’area.',
    placement: 'center'
  }
];

let _steps = ADMIN_STEPS;
let _tourEl = null;
let _tourIdx = 0;

function ensureTourDom() {
  if (_tourEl) return _tourEl;
  _tourEl = document.createElement('div');
  _tourEl.className = 'tour-overlay hidden';
  _tourEl.setAttribute('role', 'dialog');
  _tourEl.setAttribute('aria-modal', 'true');
  _tourEl.setAttribute('aria-label', 'Tour del portale');
  _tourEl.innerHTML = `
    <div class="tour-backdrop"></div>
    <div class="tour-popover">
      <div class="tour-step-label" id="tourStepLabel"></div>
      <h3 id="tourTitle"></h3>
      <p id="tourBody"></p>
      <div class="tour-actions">
        <button class="btn btn-sm" id="tourSkip">Salta tour</button>
        <span style="flex:1"></span>
        <button class="btn btn-sm" id="tourPrev">Indietro</button>
        <button class="btn btn-sm btn-primary" id="tourNext">Avanti</button>
      </div>
    </div>`;
  document.body.appendChild(_tourEl);
  _tourEl.querySelector('#tourSkip').addEventListener('click', endTour);
  _tourEl.querySelector('#tourPrev').addEventListener('click', () => moveTour(-1));
  _tourEl.querySelector('#tourNext').addEventListener('click', () => moveTour(1));
  return _tourEl;
}

function positionPopover() {
  const step = _steps[_tourIdx];
  const target = document.querySelector(step.selector);
  const pop = _tourEl.querySelector('.tour-popover');
  if (!target) {
    pop.style.left = '50%';
    pop.style.top = '50%';
    pop.style.transform = 'translate(-50%, -50%)';
    return;
  }
  const r = target.getBoundingClientRect();
  const pad = 12;
  let left = r.left;
  let top = r.bottom + pad;
  if (step.placement === 'right') {
    left = r.right + pad;
    top = r.top;
  } else if (step.placement === 'top') {
    top = r.top - 200;
  }
  // bound check
  left = Math.max(12, Math.min(left, window.innerWidth - 360));
  top = Math.max(12, Math.min(top, window.innerHeight - 240));
  pop.style.left = left + 'px';
  pop.style.top = top + 'px';
  pop.style.transform = '';
  // evidenzia target
  document
    .querySelectorAll('.tour-highlight')
    .forEach((el) => el.classList.remove('tour-highlight'));
  target.classList.add('tour-highlight');
}

function renderStep() {
  const step = _steps[_tourIdx];
  if (!step) return;
  _tourEl.querySelector('#tourTitle').textContent = step.title;
  _tourEl.querySelector('#tourBody').textContent = step.body;
  _tourEl.querySelector('#tourStepLabel').textContent =
    'Passo ' + (_tourIdx + 1) + ' di ' + _steps.length;
  _tourEl.querySelector('#tourPrev').disabled = _tourIdx === 0;
  _tourEl.querySelector('#tourNext').textContent =
    _tourIdx === _steps.length - 1 ? 'Fine' : 'Avanti';
  setTimeout(positionPopover, 30);
}

function moveTour(delta) {
  _tourIdx += delta;
  if (_tourIdx >= _steps.length) return endTour(true);
  if (_tourIdx < 0) _tourIdx = 0;
  renderStep();
}

function startTour() {
  ensureTourDom();
  _steps = typeof isAdmin === 'function' && isAdmin() ? ADMIN_STEPS : USER_STEPS;
  _tourIdx = 0;
  _tourEl.classList.remove('hidden');
  renderStep();
  window.addEventListener('resize', positionPopover);
}

function endTour(completed) {
  if (_tourEl) _tourEl.classList.add('hidden');
  document
    .querySelectorAll('.tour-highlight')
    .forEach((el) => el.classList.remove('tour-highlight'));
  window.removeEventListener('resize', positionPopover);
  if (typeof saveUserPrefs === 'function') {
    saveUserPrefs({ tour_seen: true });
  }
  if (completed) toast('Tour completato. Buon lavoro!');
}

async function maybeStartOnboarding() {
  // Il tour parte al primo accesso per TUTTI i ruoli (admin e utenti): i passi
  // sono diversi a seconda del ruolo (vedi ADMIN_STEPS / USER_STEPS).
  if (typeof getUserPrefs !== 'function') return;
  const prefs = getUserPrefs();
  if (prefs && prefs.tour_seen === true) return;
  // Avvia con un piccolo delay perché il DOM completo (e i conteggi) siano pronti
  setTimeout(startTour, 1200);
}

// ====== Help contestuale: tooltip espandibile su click ======
function wireHelpTooltips() {
  document.querySelectorAll('[data-help]').forEach((el) => {
    if (el.dataset.helpWired === '1') return;
    el.dataset.helpWired = '1';
    // Inserisci un piccolo "?" cliccabile dopo l'elemento (se non già presente)
    const helpText = el.getAttribute('data-help');
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'help-tip-btn';
    btn.setAttribute('aria-label', 'Mostra aiuto contestuale');
    btn.innerHTML = `<span class="help-tip-q">?</span><span class="help-tip-pop">${escapeHtml(helpText)}</span>`;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      btn.classList.toggle('open');
    });
    document.addEventListener('click', () => btn.classList.remove('open'));
    el.appendChild(btn);
  });
}

// Pulsante "Rilancia tour" in Impostazioni. La vista è lazy: il bottone va
// aggiunto SOLO quando il contenuto è montato (altrimenti l'innerHTML del loader
// lo sovrascrive). Idempotente.
function mountRelaunchTourButton() {
  const sect = document.getElementById('view-impostazioni');
  if (!sect || document.getElementById('btnRelaunchTour')) return;
  if (!sect.querySelector('.card')) return; // ancora stub lazy vuoto
  const wrap = document.createElement('div');
  wrap.style.cssText = 'margin: 16px 0 24px;';
  wrap.innerHTML = '<button class="btn btn-sm" id="btnRelaunchTour">Rilancia tour guidato</button>';
  sect.appendChild(wrap);
  document.getElementById('btnRelaunchTour').addEventListener('click', startTour);
}

// Auto-bootstrap dopo il login (richiamato anche da renderProfilo via "rilancia tour")
document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('btnHelp')?.addEventListener('click', () => startTour());
  setTimeout(() => {
    mountRelaunchTourButton();
    wireHelpTooltips();
  }, 600);
});
// Quando la vista Impostazioni viene caricata lazy, aggiungi il bottone tour.
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'impostazioni') mountRelaunchTourButton();
  // Aggancia il "?" di aiuto contestuale anche agli elementi della vista appena caricata.
  wireHelpTooltips();
});

Object.assign(globalThis, { startTour, endTour, maybeStartOnboarding, wireHelpTooltips });
export {};
